const geoCoverage = {
  california: {
    'agoura-hills': ['91301', '91376'],
    'alhambra': ['91803', '91804'],
    'anaheim': ['92801', '92802', '92803', '92804', '92805', '92806', '92807', '92808', '92809'],
    'arcadia': ['91006', '91007'],
    'artesia': ['90702'],
    'azusa': ['91702'],
    'bel-air': ['90077', '90049'],
    'bell-gardens': ['90201', '90202'],
    'bellflower': ['90706'],
    'beverly-hills': ['90210', '90211', '90212'],
    'brea': ['92821'],
    'buena-park': ['90620', '90621'],
    'burbank': ['91501', '91503', '91504', '91505', '91506'],
    'calabasas': ['91302'],
    'camarillo': ['93010', '93012'],
    'canoga-park': ['91303', '91304', '91305'],
    'carson': ['90745', '90746', '90747', '90810'],
    'castaic': ['91310'],
    'cerritos': ['90703'],
    'chatsworth': ['91311', '91313'],
    'chino': ['91708', '91710'],
    'chino-hills': ['91709'],
    'claremont': ['91711'],
    'compton': ['90220', '90221', '90222', '90223', '90224'],
    'costa-mesa': ['92626', '92627', '92628'],
    'culver-city': ['90230'],
    'cypress': ['90630'],
    'diamond-bar': ['91765'],
    'downey': ['90240', '90241', '90242'],
    'duarte': ['91008'],
    'east-los-angeles': ['90022', '90023', '90063'],
    'el-monte': ['91731', '91732'],
    'el-segundo': ['90245'],
    'encino': ['91316'],
    'fullerton': ['92831', '92832', '92833', '92835'],
    'garden-grove': ['92840', '92841', '92843', '92844', '92845'],
    'gardena': ['90247', '90248', '90249'],
    'glendale': ['91201', '91202', '91203', '91204', '91205', '91206', '91207', '91208', '91214'],
    'granada-hills': ['91344'],
    'hawaiian-gardens': ['90716'],
    'hawthorne': ['90250'],
    'hermosa-beach': ['90254'],
    'huntington-beach': ['92646', '92647', '92648', '92649'],
    'huntington-park': ['90255'],
    'inglewood': ['90301', '90302', '90303', '90304', '90305'],
    'irvine': ['92602', '92603', '92604', '92606', '92612', '92614', '92617', '92618', '92619', '92620'],
    'la-canada-flintridge': ['91011', '91012'],
    'la-mirada': ['90637', '90638'],
    'la-palma': ['90623'],
    'la-puente': ['91744', '91746', '91747', '91749'],
    'la-verne': ['91750'],
    'lake-balboa': ['91406'],
    'lake-view-terrace': ['91342'],
    'lakewood': ['90712', '90713', '90714'],
    'lancaster': ['93534', '93535', '93536'],
    'lawndale': ['90260'],
    'lomita': ['90717'],
    'long-beach': ['90802', '90803', '90804', '90805', '90806', '90807', '90808', '90813', '90814', '90815'],
    'los-alamitos': ['90720'],
    'los-angeles': ['90001', '90002', '90003', '90004', '90005', '90006', '90007', '90008', '90010', '90011', '90012', '90013', '90014', '90015', '90016', '90017', '90018', '90019', '90020', '90021', '90024', '90026', '90027', '90028', '90029', '90031', '90032', '90033', '90034', '90035', '90036', '90037', '90038', '90039', '90041', '90042', '90043', '90044', '90045', '90046', '90047', '90048', '90056', '90057', '90059', '90061', '90062', '90063', '90064', '90066', '90067', '90068', '90069', '90071', '90077'],
    'lynwood': ['90262'],
    'malibu': ['90263', '90264', '90265'],
    'manhattan-beach': ['90266', '90267'],
    'mission-hills': ['91345', '91346'],
    'monrovia': ['91016'],
    'montebello': ['90640'],
    'monterey-park': ['91754', '91755'],
    'moorpark': ['93020', '93021'],
    'mount-washington': ['90065'],
    'newport-beach': ['92657', '92660', '92661', '92662', '92663'],
    'north-hills': ['91343'],
    'north-hollywood': ['91601', '91602', '91603', '91605', '91606'],
    'norwalk': ['90650'],
    'oak-park': ['91377'],
    'pacific-palisades': ['90272'],
    'palmdale': ['93550', '93551', '93552'],
    'palos-verdes-estates': ['90274'],
    'panorama-city': ['91402', '91412'],
    'paramount': ['90723'],
    'pasadena': ['91101', '91103', '91104', '91105', '91106', '91107', '91108', '91114'],
    'pico-rivera': ['90660', '90661'],
    'placentia': ['92870'],
    'porter-ranch': ['91326'],
    'puente': ['91746'],
    'rancho-cucamonga': ['91701', '91730', '91737', '91739'],
    'redondo-beach': ['90277', '90278'],
    'reseda': ['91335'],
    'rolling-hills-estates': ['90274', '90275'],
    'rosemead': ['91770', '91772'],
    'rowland-heights': ['91748'],
    'san-dimas': ['91773'],
    'san-fernando': ['91340', '91341'],
    'san-gabriel': ['91775', '91776', '91778'],
    'santa-ana': ['92701', '92702', '92703', '92704', '92705', '92706', '92707'],
    'santa-clarita': ['91350', '91351', '91354', '91355', '91380', '91382', '91383', '91385', '91386', '91387', '91390'],
    'santa-fe-springs': ['90670'],
    'santa-monica': ['90401', '90402', '90403', '90404', '90405'],
    'seal-beach': ['90740'],
    'sherman-oaks': ['91403', '91423'],
    'simi-valley': ['93062', '93063', '93064'],
    'south-el-monte': ['91733'],
    'south-gate': ['90280'],
    'south-pasadena': ['91030', '91031'],
    'stevenson-ranch': ['91381'],
    'studio-city': ['91604'],
    'sun-valley': ['91352'],
    'sylmar': ['91342', '91392'],
    'tarzana': ['91356', '91357'],
    'temple-city': ['91780'],
    'thousand-oaks': ['91358', '91360', '91361', '91362'],
    'toluca-lake': ['91602', '91610'],
    'torrance': ['90501', '90502', '90503', '90504', '90505'],
    'tustin': ['92780', '92782'],
    'upland': ['91784', '91786'],
    'valley-glen': ['91401', '91405'],
    'valley-village': ['91601', '91607'],
    'villa-park': ['92861'],
    'walnut': ['91788', '91789'],
    'west-covina': ['91790', '91791', '91792', '91793'],
    'west-hollywood': ['90038', '90046', '90048', '90069'],
    'westlake-village': ['91361', '91362'],
    'westminster': ['92683', '92684', '92685'],
    'whittier': ['90601', '90602', '90603', '90604', '90605', '90606'],
    'winnetka': ['91306'],
    'woodland-hills': ['91364', '91365', '91367'],
    'yorba-linda': ['92886', '92887'],
    'corona': ['92877', '92878', '92879', '92880', '92881', '92882', '92883'],
    'fillmore': ['93016'],
    'fontana': ['92331', '92334', '92335', '92336', '92337'],
    'fountain-valley': ['92708', '92728'],
    'glendora': ['91740', '91741'],
    'newbury-park': ['91320', '91319'],
    'ontario': ['91758', '91761', '91762', '91764'],
    'orange': ['92864', '92865', '92866', '92867', '92868', '92869'],
    'riverside': ['92501', '92503', '92504', '92505', '92506', '92507', '92508', '92509', '92518'],
    'san-bernardino': ['92401', '92404', '92405', '92407', '92408', '92410', '92411', '92415'],
    'palm-desert': ['92211', '92255', '92260', '92261'],
    'palm-springs': ['92262', '92263', '92264'],
    'twentynine-palms': ['92277', '92278'],
    'yucca-valley': ['92284', '92286'],
    'morongo-valley': ['92256'],
    'desert-hot-springs': ['92240', '92241'],
  }
};

export default geoCoverage;
